/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { useFindMeQuery } from '@hook/auth/useApi';
import TextBlock from '@component/common/block/text-block';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import Gap from '@component/common/gap';
import { MOASHELF_PATH } from '@constant/moashelf/route-path';
import { useNavigate } from 'react-router-dom';
import { actions as navigationActions } from '@store/slice/navigation-slice';

const Wrapper = styled.div`
  height: 100%;
`;

const SubscriptionMailContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-end;
  gap: ${size.MARGIN_1};
`;

const TEXT_DESIGN = {
  text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'medium' : 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left' },
} as const;

const COPY_TEXT_DESIGN = {
  text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'medium' : 'tiny', color: color.GRAY_1, bold: false },
  box: { alignX: 'left', event: { cursor: 'pointer' } },
} as const;

const BUTTON_DESIGN = {
  text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'medium' : 'medium', color: color.WHITE_1, bold: false },
  box: {
    alignX: 'center',
    event: { cursor: 'pointer' },
    backgroundColor: color.BLACK_2,
    borderRadius: size.BORDER_RADIUS_2,
    height: IS_IYAGIGO_MOBILE_VIEW ? '45px' : '35px',
    width: IS_IYAGIGO_MOBILE_VIEW ? '200px' : '150px',
  },
} as const;

const BeginFind: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const meQuery = useFindMeQuery();
  const catchEmail = meQuery.data?.data?.catchEmail ?? '';
  const handleCopyTextClick = () => {
    navigator.clipboard.writeText(catchEmail);
  };
  const handleFindClick = () => {
    dispatch(navigationActions.storeMoashelfSubMenu('begin-find'));
    navigate(MOASHELF_PATH.BEGIN_PATH);
  };

  return (
    <Wrapper>
      <Gap height={size.MARGIN_2} />
      <TextBlock text={'나의 구독메일로 뉴스레터를 구독하면'} design={TEXT_DESIGN} />
      <Gap height={'5px'} />
      <TextBlock text={'Moashelf에서 간편하게 관리할 수 있습니다. 😊'} design={TEXT_DESIGN} />
      <Gap height={size.MARGIN_2} />
      <SubscriptionMailContainer>
        <TextBlock
          text={'✉️ 나의 구독메일'}
          design={{ box: TEXT_DESIGN.box, text: { ...TEXT_DESIGN.text, bold: true } }}
        />
        <TextBlock text={'복사하기'} design={COPY_TEXT_DESIGN} click={{ handler: handleCopyTextClick }} />
      </SubscriptionMailContainer>
      <Gap height={'5px'} />
      <TextBlock text={catchEmail} design={TEXT_DESIGN} />
      <Gap height={size.MARGIN_4} />
      <TextBlock text={'뉴스레터 찾아보기'} design={BUTTON_DESIGN} click={{ handler: handleFindClick }} />
    </Wrapper>
  );
};

export default BeginFind;
